import type { ITaggerFilter } from '~/features-shared/tags/interfaces/tags'

export interface IContentsRefine {
  refine: string[]
  query: string
  filter: ITaggerFilter
}

const routeFiltersMap = reactive(new Map<string, IContentsRefine>())

export const getRefineParams = (route: string) => routeFiltersMap.get(route)
export const setRefineParams = (route: string, refineParams: IContentsRefine) => routeFiltersMap.set(route, refineParams)
